export default () => ({
  searchTerm: null,
  brands: null,
  minPrice: null,
  maxPrice: null,
  sections: null,
})
